<template>
  <div class="tla-vehicle-result">
    <div class="tla-vehicle-result__result">
      <div class="tla-vehicle-result__item">
        <div class="tla-vehicle-result__label">Vehicle</div>
        <div class="tla-vehicle-result__description">{{vehicleValuation.vehicle.name}}</div>
      </div>
      <div class="tla-vehicle-result__item">
        <div class="tla-vehicle-result__label">Plate Year</div>
        <div class="tla-vehicle-result__description">{{vehicleValuation.vehicle.plateYear}}</div>
      </div>
    </div>
    <button
      class="tla-btn tla-btn--info"
      @click="closeOverlay()"
      name="vehicle-lookup-confirmation-button"
      id="vehicle-lookup-confirmation-button">
      This is my car
    </button>
    <button
      class="tla-btn tla-btn--link tla-btn--spaced-bottom-sm"
      @click="manualVehicleEntry()"
      name="vehicle-lookup-wrong-button"
      id="vehicle-lookup-wrong-button">
      This isn't my car
    </button>
    <span class="tla-vehicle-result__disclaimer">The vehicle found is based on the registration number provided.</span>
  </div>
</template>
<script lang="ts">
import {
  Component, Vue, Prop, Provide, Inject
} from 'vue-property-decorator';
import {
  State, Getter, Action, namespace
} from 'vuex-class';
import Valuation from '@/models/valuation/Valuation';
import StartAgainComponent from '@/components/navigation/StartAgainComponent.vue';
import VehicleModuleOptions from '@/models/VehicleModuleOptions';
import VehicleType from '@/enums/VehicleType';
import VehicleLevel from '@/enums/VehicleLevel';
import VehicleStatusType from '@/enums/VehicleStatusType';
import { Validator } from 'vee-validate';

@Component({
  components: {
  StartAgainComponent
  }
  })
export default class RegistrationLookupResultComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'registrationLookup' })
  public validationScope!: string;

  public manualVehicleEntry() {
    this.$emit('createManualVehicleModules', this.currentOverlayStep + 1);
  }

  public get currentOverlayStep(): number {
    return this.$store.getters['enquiryModule/currentOverlayStep'];
  }

  public get vehicleValuation(): Valuation {
    return this.$store.getters['vehicleValuationModule/vehicleValuation'];
  }

  public setVehicle() {
    this.$store.dispatch('vehicleValuationModule/submitValuationExtraData', this.vehicleValuation);
  }

  public closeOverlay() {
    this.$emit('closeOverlay');
  }
}
</script>
